export default "__VITE_ASSET__DHXVayqV__"